module.exports = __webpack_public_path__ + "img/azure-lock.5cf49f58.png";